import { Badge } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { StyledParenthesisedContent } from "app/pages/sales-intelligence/common-components/styles";

import { StyledPanelTitle } from "./styles";

type Props = {
    currentSearchName?: string;
    numberOfFilters?: number;
    withBetaTag?: boolean;
};

export const CollapsiblePanelTitle = (props: Props) => {
    const { currentSearchName, numberOfFilters = 0, withBetaTag = false } = props;

    const content =
        typeof currentSearchName === "undefined" ? (
            <span data-automation="filters-title-text">
                {translate("si.lead_gen_filters.title")}

                {numberOfFilters > 0 ? (
                    <StyledParenthesisedContent>{numberOfFilters}</StyledParenthesisedContent>
                ) : null}
            </span>
        ) : (
            <span data-automation="selected-search-text">{currentSearchName}</span>
        );

    if (withBetaTag) {
        return (
            <Flex
                gap="8px"
                alignItems="center"
            >
                <StyledPanelTitle data-automation="filters-panel.title">{content}</StyledPanelTitle>
                <Badge type="beta" />
            </Flex>
        );
    }

    return <StyledPanelTitle data-automation="filters-panel.title">{content}</StyledPanelTitle>;
};
